import type { LibraryUsageDto } from "../api/types";

/** How many rules and library entries cite a set; zero means it is unused. */
export const usageCount = (usage: LibraryUsageDto): number =>
  usage.rules.length + usage.matchSets.length + usage.actionSets.length;
